import React from "react"
import Tilt from 'react-parallax-tilt'
import { motion } from "framer-motion"

export const MyComponent = ({ isVisible }) => (
    <motion.div animate={{ opacity: isVisible ? 1 : 0 }} />
)
const scaleVarience={
  whileInView:{
    scale:[0,1],
    opacity:[0,1],
    transition:{
      duration:0.5,
      ease:'easeInOut'
    },

  },
};
const Card = (props) => {
  return (
    <>
    <Tilt>
      <motion.div
       varience={scaleVarience}
       whileInView={scaleVarience.whileInView}
       >
      <div className='box btn_shadow'>
        <img src={props.image} alt='' />
        <h2>{props.title}</h2>
        <p>{props.desc}</p>
        {/* <a href='/'>
          <i className='fas fa-arrow-right'></i>
        </a> */}
      </div>
      </motion.div>
      </Tilt>
      
    </>
  )
}

export default Card
